import type { CartConfig } from '#types/config/pages/cart'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    floatingCta: () => 'ml-3',
    header: 'md:mb-6',
    headerDivider: 'mx-2 c-grey-70',
    headerTitle: 'subtitle-3 md:|title-2',
    headerTotalItems: 'body-3 flex items-center justify-end',
    itemsPerShipping: 'md:mb-4',
    noItems: 'mx-a py-20 -mt-4 md:mt-0 text-center subtitle-3',
  },
  brandStyles: {
    floatingCta: 'padding: 0.645rem',
  },
  item: {
    links: 'body-3',
    actionMenu: {
      brandClasses: {
        button: 'py-2 px-4 gap-2 items-center',
        list: 'divide-grey-70'
      },
      dialogOptions: { type: 'panel' },
      iconSize: 'lg'
    },
  },
  outOfStock: {
    dialogOptions: { type: 'panel' },
    showRemoveAll: false,
    showRemoveItem: false,
    showSaveForLater: false
  },
  quickshop: {
    dialogOptions: {
      type: 'panel',
      position: { sm: 'bottom', lg: 'right' }
    }
  },
  savedForLater: {
    dialogOptions: { type: 'panel' },
    moveToCartIcon: 'cart'
  }
} satisfies RecursivePartial<CartConfig>
